/* unplugin-vue-components disabled */import script from "./RecommendConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendConfigure.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__